import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import { SelectButtonCombo } from "components/formFields/SelectButtonCombo";

import { i18n } from "services/i18nService";
import { afterTouchLine } from "services/sosInventoryService/fulfillmentTransaction/afterTouchLine";
import { getRecord } from "services/sosInventoryService/sosApi";
import { setPageDirty } from "services/utility/edit";
import { getAddOrderPlaceholder } from "services/utility/misc";

import { useCustomerData } from "hooks/useCustomerData";

import {
  editModalLoadingIndicatorOn,
  editModalLoadingIndicatorOff,
} from "globalState/loadingSlice";

import { getObjectFromFullString, OBJECT_TYPES } from "appConstants";

const RETURN = OBJECT_TYPES.RETURN.fullString;

export function AddRma(props) {
  const { customer, lineHandler } = props;

  const dispatch = useDispatch();

  const [value, setValue] = useState(null);
  const options = useCustomerData(customer, RETURN);

  // reset the selection whenever the customer changes
  useEffect(() => setValue(null), [customer]);

  async function addOrder() {
    if (!value) {
      return;
    }

    const { objectType, txnId } = value;
    dispatch(editModalLoadingIndicatorOn());
    const sourceOrder = await getRecord(objectType, txnId);

    const nonZeroLines = sourceOrder.lines.filter(({ returned, quantity }) =>
      returned.lt(quantity)
    );
    const transactionType = getObjectFromFullString(objectType).shortString;
    const newLines = await Promise.all(
      nonZeroLines.map(async (line) => {
        const item = await getRecord("item", line.item.id);
        const newLine = {
          ...line,
          linkedTransaction: {
            id: sourceOrder.id,
            refNumber: sourceOrder.number,
            lineNumber: line.lineNumber,
            transactionType,
          },
          quantity: line.quantity.minus(line.returned),
          relatedRecords: { item },
          itemDetails: {
            itemWeight: item.weight,
            itemVolume: item.volume,
            itemUoms: item.uoms,
            serialTracking: item.serialTracking,
            lotTracking: item.lotTracking,
          },
        };
        delete newLine.id;
        return afterTouchLine(newLine, "quantity");
      })
    );
    if (newLines.length) {
      setPageDirty();
      lineHandler({ type: "append", newLines });
    }
    dispatch(editModalLoadingIndicatorOff());
  }

  return (
    <SelectButtonCombo
      key={options}
      disableClearable
      minWidth="12rem"
      maxWidth="12rem"
      selectLabel={i18n("frmLabel.AddRMA")}
      buttonLabel={i18n("global.Add")}
      value={value}
      onValueChange={(_, { id }) => setValue(options.find((o) => o.id === id))}
      onClick={addOrder}
      options={options}
      placeholder={getAddOrderPlaceholder(options, i18n("addOrder.SelectRMA"))}
      disabled={!Boolean(customer)}
    />
  );
}
